export default "__VITE_ASSET__DgdFI4Bt__"